import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { aboutContent } from '../data/mock';
import SEO from '../components/common/SEO';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        url="/about"
        title="About the Artist"
        description="Learn about Gorito, a Swedish artist creating original paintings and fine art prints. Discover the inspiration, artistic process, and story behind the artwork."
      />
      <Header />
      <main>
        {/* Hero Section */}
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-light text-gray-900" style={{ fontFamily: 'Georgia, serif' }}>
              {aboutContent.title}
            </h1>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden rounded-lg">
                <img
                  src={aboutContent.image}
                  alt="Artist at work"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gray-100 rounded-lg -z-10" />
            </div>

            {/* Text Content */}
            <div className="lg:pl-8">
              <h2 className="text-2xl md:text-3xl font-light text-gray-900 mb-6" style={{ fontFamily: 'Georgia, serif' }}>
                The Artist
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                {aboutContent.bio}
              </p>
              <p className="text-gray-600 leading-relaxed mb-6">
                {aboutContent.story}
              </p>
              <blockquote className="border-l-4 border-black pl-6 italic text-gray-700 my-8">
                "{aboutContent.mission}"
              </blockquote>
            </div>
          </div>

          {/* Process Section */}
          <div id="process" className="mt-24">
            <h2 className="text-3xl font-light text-gray-900 text-center mb-12" style={{ fontFamily: 'Georgia, serif' }}>
              My Creative Process
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-light text-gray-700">01</span>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-3">Inspiration</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Every piece starts with inspiration—from music, culture, emotions, or the world around us.
                </p>
              </div>
              <div className="text-center p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-light text-gray-700">02</span>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-3">Creation</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Using digital tools and traditional techniques, each artwork is carefully crafted with attention to color and emotion.
                </p>
              </div>
              <div className="text-center p-8">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-light text-gray-700">03</span>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-3">Production</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Prints are produced using museum-quality giclée printing on premium archival paper.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
